import React from 'react';

import { graphql, useGqlContext } from '@search/gql-client/src';
import {
    UnsubscribePriceChangeMutation$data as UnsubscribePriceChangeMutationResponse, UnsubscribePriceChangeMutation$variables as UnsubscribePriceChangeMutationVariables
} from './__generated__/UnsubscribePriceChangeMutation.graphql';

const unsubscribePriceChangeMutation = graphql`
  mutation UnsubscribePriceChangeMutation($offerId: ID!, $userId: ID!) {
    unsubscribeFromPriceChangeOpen(offerId: $offerId, userId: $userId) {
        isUnsubscribed
        firstError {
            __typename
            ... on BaseError {
                message
            }
            ... on AuthUserIdError {
                message
            }
            ... on UnsubscribeFromPriceChangeOpenErrorInvalidId {
                message
            }
            ... on UnsubscribeFromPriceChangeOpenErrorNotExists {
                message
            }
        }
    }
  }
`;

export const useUnsubscribePriceChangeMutation = () => {
    const gql = useGqlContext();

    return React.useCallback((props: UnsubscribePriceChangeMutationVariables) => {
        return gql.client<UnsubscribePriceChangeMutationVariables, UnsubscribePriceChangeMutationResponse>(
            unsubscribePriceChangeMutation,
            props
        );
    }, [ ]);
};
